<!-- <div class="innerBanner" style="background-image: url('{{ privacyDetails.bannerImage }}')"> -->
<!-- <img
      [src]="privacyDetails.bannerImage ? privacyDetails.bannerImage : '../../../assets/images/NoImage.jpg'"
      style="width: 100%"
    /> -->
<!-- <div class="bannerText"></div>
</div> -->

<div class="innerBanner" [style.background-image]="'url(' + bannerImage + ')'" (click)="imageClick(0)"></div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<div class="container contentPanel">
  <!-- <app-breadcrumb></app-breadcrumb> -->
  <nav aria-label="breadcrumb">
    <!-- <ol class="breadcrumb"> -->
    <!-- <li class="breadcrumb-item"><a href="/home">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">{{ privacyDetails.bannerTitle }}</li> -->
    <!-- </ol> -->
  </nav>
  <!-- <h1>{{ privacyDetails.bannerTitle }}</h1> -->
  <div class="pageTitle">
    <div class="privacyPolicy" #privacyPolicy>
      <p-toast position="top-center" key="logout"></p-toast>
      <div class="reset-pass-container resetPassword">
        <div class="reset-pass-box">
          <h1 translate>{{ 'Reset Your Password' | translate }}</h1>
          <p-toast position="top-center" key="c" (onClose)="onReject()" [baseZIndex]="5000" style="margin-top: 250px">
            <ng-template let-message pTemplate="message">
              <div class="p-flex p-flex-column" style="flex: 1">
                <div class="p-text-center">
                  <!-- <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i> -->
                  <p class="m-0">{{ confirmMessage }}</p>
                  <p>{{ confirmMessageSummary }}</p>
                </div>
                <div>
                  <div class="p-text-center">
                    <p-button label="OK" (click)="onReject()" styleClass="p-button-text"></p-button>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-toast>
          <div class="container">
            <div class="card col-md-6 col-xl-5 mt-3 mx-auto">
              <div class="card-body">
                <form [formGroup]="changePasswordForm" (ngSubmit)="submit()" novalidate>
                  <label>{{ 'New Password' | translate }}<i class="text-danger" aria-hidden="true">*</i></label>
                  <label class="d-block">
                    <input
                      [type]="fieldPasswordType ? 'text' : 'password'"
                      class="form-control"
                      formControlName="password"
                      autocomplete="password"
                      placeholder="{{ 'New Password' | translate }}"
                      maxlength="30"
                      pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*)(?=.*\W.*)[a-zA-Z0-9\S]{8,15}$"
                      required
                    />
                    <i
                      class="fa passwordShow"
                      [ngClass]="{
                        'fa-eye-slash': !fieldPasswordType,
                        'fa-eye': fieldPasswordType
                      }"
                      (click)="togglePasswordType()"
                    ></i>
                    <span hidden translate>{{ 'Confirm New Password ' | translate }} New passwor</span>
                    <small
                      class="text-danger"
                      *ngIf="
                        !changePasswordForm.controls['password'].valid &&
                        (changePasswordForm.controls['password'].dirty ||
                          changePasswordForm.controls['password'].touched)
                      "
                    >
                      <span *ngIf="changePasswordForm.controls['password'].errors?.required">{{
                        'Require NewPWD' | translate
                      }}</span>
                      <span *ngIf="changePasswordForm.controls['password'].errors?.pattern">{{
                        'Valid Password' | translate
                      }}</span>
                    </small>
                  </label>
                  <label>{{ 'Retype new Password' | translate }}<i class="text-danger" aria-hidden="true">*</i></label>
                  <label class="d-block">
                    <input
                      [type]="fieldConfirmPasswordType ? 'text' : 'password'"
                      class="form-control"
                      formControlName="confirmPassword"
                      autocomplete="current-password"
                      placeholder="{{ 'New Password' | translate }}"
                      maxlength="30"
                      required
                    />
                    <i
                      class="fa passwordShow"
                      [ngClass]="{
                        'fa-eye-slash': !fieldConfirmPasswordType,
                        'fa-eye': fieldConfirmPasswordType
                      }"
                      (click)="toggleConfirmPasswordType()"
                    ></i>
                    <span hidden translate
                      >{{ 'Confirm Password' | translate }}<i class="text-danger" aria-hidden="true">*</i></span
                    >
                    <small
                      [hidden]="
                        changePasswordForm.controls.confirmPassword.valid ||
                        changePasswordForm.controls.confirmPassword.untouched
                      "
                      class="text-danger"
                      translate
                    >
                      {{ 'Require Confirm Password' | translate }}
                    </small>
                    <span
                      class="text-danger"
                      *ngIf="
                        changePasswordForm.controls['confirmPassword'].valid &&
                        (changePasswordForm.controls['confirmPassword'].dirty ||
                          changePasswordForm.controls['confirmPassword'].touched)
                      "
                    >
                      <small
                        *ngIf="
                          changePasswordForm.controls['password'].value !=
                          changePasswordForm.controls['confirmPassword'].value
                        "
                        >{{ 'New Passwords Match' | translate }}</small
                      >
                    </span>
                  </label>
                  <button type="submit" class="btn btn-primary" [disabled]="changePasswordForm.invalid">
                    {{ 'Reset Password' | translate }}
                  </button>
                  <a href="/home" class="btn btn-primary float-right">{{ 'Cancel' | translate }}</a>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
    </div>
  </div>
</div>
